export function sortArrayToDesiredOrder<T>({
    data,
    getSortingValue,
    desiredOrder,
}: {
    data: T[]
    getSortingValue: (t: T) => string
    desiredOrder: string[] | readonly string[]
}) {
    const orderIndex = new Map(desiredOrder.map((v, i) => [v, i]))
    data.slice().sort((a, b) => {
        const aSortingValue = getSortingValue(a)
        const bSortingValue = getSortingValue(b)
        const aIndex = (
            orderIndex.has(aSortingValue) ? orderIndex.get(aSortingValue) : Infinity
        ) as number
        const bIndex = (
            orderIndex.has(bSortingValue) ? orderIndex.get(bSortingValue) : Infinity
        ) as number
        return aIndex - bIndex
    })
}
